import { Question } from './question';
export class Chapter {
  _id: string;
  title: string;
  sortWeight: number;
  topics: Topic[] = [];
  chapterQuiz: Question[] = [];
}

export class Topic {
  _id: string;
  title: string;
  content: string;
  sortWeight: number;
  videos: Video[] = [];
  quiz: Question[] = [];
}

export class Video {
  title: string;
  videoUrl: string;
  embed: any;
}

